import React, { Suspense, useContext, useEffect, useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Col, Dropdown, Layout, Menu, Space, theme } from 'antd';
import CandidateLogin from '../pages/CandidateLogin';
import { Link, Route, Routes } from 'react-router-dom';
import Mainmenu from '../components/Mainmenu';
import { faBell, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Messages from '../pages/Messages';
import AppointmentScheduleVisit from '../pages/AppointmentScheduleVisit';
import AppointmentDetailSchedule from '../pages/AppointmentDetailSchedule';
import { DownOutlined } from "@ant-design/icons";
import EditProfile from '../pages/EditProfile';
import { DataContext } from '../store/DataContext';


const Profile = React.lazy(() => import('../pages/Profile'));
const MedicalRecords = React.lazy(() => import('../pages/MedicalRecords'));
const Forms = React.lazy(() => import('../pages/Forms'));
const Billing = React.lazy(() => import('../pages/Billing'));
const Spinner = React.lazy(() => import('../components/Spinner'));
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const Appointement = React.lazy(() => import('../pages/Appointment'));
const ScheduleAppointment = React.lazy(() => import('../pages/ScheduleAppointments'));
const AppointmentRequest = React.lazy(() => import('../pages/AppointmentRequest'));
const PageNotfound = React.lazy(() => import('../components/PageNF'));



const { Header, Content, Footer, Sider } = Layout;

const CandidateLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const { profile, image } = useContext(DataContext);
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const handleResize = () => {
        var screenWidth = window.innerWidth;
        if (screenWidth <= 1000) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
    };

    const items = [
        {
            label: (<><Link to="/editprofile" className='text-decoration-none'>Edit Profile</Link></>),
            key: '1',
        },
        {
            label: 'Logout',
            key: '2',
        },
    ];
    const menu = (
        <Menu
            items={[
                {
                    key: "1",
                    label: <a href="javascript:void(0);" className='text-decoration-none'>Profile Updated  </a>,
                },
                {
                    key: "2",
                    label: <a href="javascript:void(0);" className='text-decoration-none'>Update Contact</a>,
                },
                {
                    key: "3",
                    label: <a href="javascript:void(0);" className='text-decoration-none'>Status Details</a>,
                },
            ]}
        />
    );



    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        const handleStorageChange = () => {
            const newValue = localStorage.getItem('userName') || 'Emma Shelton';
            setProfile(newValue);
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        <Layout>
            <Sider
                breakpoint="lg"
                collapsedWidth="60px"
                onBreakpoint={(broken) => {
                }}
                trigger={null} collapsible collapsed={collapsed}
                style={{
                    background: colorBgContainer,
                }}
            >
                <div className="demo-logo-vertical" style={{ height: "20px" }} />
                <Mainmenu />
            </Sider>
            <Layout>
                <Header style={{ padding: 0, background: colorBgContainer }} className='d-flex align-items-center'>
                    <Col xl={10} lg={8} md={7} sm={6}>
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{
                                fontSize: '20px',
                                width: 50,
                                height: 50,
                            }}
                        />
                    </Col>
                    <Col lg={9} xl={9} md={9} sm={10} xs={6}>
                        <h3 className=' mb-0' style={{ fontSize: "20px", }}>GREEN HEALTH</h3>
                    </Col>
                    <Col lg={1} xl={1} md={1} sm={1} className='text-end'>
                        <Dropdown overlay={menu} placement="bottom" arrow >
                            <a onClick={(e) => e.preventDefault()} href="javascript:void(0)" className="drp-down">
                                <Space>
                                    <FontAwesomeIcon icon={faBell} className='fs-5 text-black pointer' />
                                </Space>
                            </a>
                        </Dropdown>
                    </Col>
                    <Col lg={4} xl={4} md={4} sm={4} className='text-center'>
                        <Dropdown menu={{ items }} key={items.key} arrow="true">
                            <a onClick={(e) => e.preventDefault()} href="javascript:void(0)" className="drp-down">
                                <Space>
                                    <span className="userImg">
                                        {/* <FontAwesomeIcon icon={faUser} className='text-black fs-5' /> */}
                                        <img src={require("../assets/images/" + image + ".png")} alt={image} style={{ width: "50px", borderRadius: "20px" }} />
                                    </span>
                                    <span className="userName text-black fs-6">{profile}</span>
                                    <DownOutlined className='text-black' />
                                </Space>
                            </a>
                        </Dropdown>
                    </Col>
                </Header>
                <Content style={{ margin: '16px 18px 0', }}>
                    <div style={{ minHeight: 680 }}>
                        <Suspense fallback={Spinner}>
                            <Routes>
                                <Route exact path="/" element={<Dashboard />} />
                                <Route exact path="/profile" element={<Profile />} />
                                <Route exact path="/appointments" element={<Appointement />} />
                                <Route exact path="/scheduleAppointment" element={<ScheduleAppointment />} />
                                <Route exact path="/appointmentrequest" element={<AppointmentRequest />} />
                                <Route exact path='/healthrecords' element={<MedicalRecords />} />
                                <Route exact path='/messages' element={<Messages />} />
                                <Route exact path='/appointmentscheduleevisit' element={<AppointmentScheduleVisit />} />
                                <Route exact path='/appointmentdetailschedule' element={<AppointmentDetailSchedule />} />
                                <Route exact path='/forms' element={<Forms />} />
                                <Route exact path='/billing' element={<Billing />} />
                                <Route exact path='/editprofile' element={<EditProfile />} />
                                <Route exact path='*' element={<PageNotfound />} />

                            </Routes>
                        </Suspense >
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default CandidateLayout;
